import { render } from "./ProviderComparisonTable.vue?vue&type=template&id=42bf718f&scoped=true"
import script from "./ProviderComparisonTable.vue?vue&type=script&lang=js"
export * from "./ProviderComparisonTable.vue?vue&type=script&lang=js"

import "./ProviderComparisonTable.vue?vue&type=style&index=0&id=42bf718f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bf718f"]])

export default __exports__